import React from "react";

function heatEnabled(){
    return (
      <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" fill="none">
      <path d="M11.7451 23C17.8202 23 22.7451 18.0751 22.7451 12C22.7451 5.92487 17.8202 1 11.7451 1C5.66998 1 0.745117 5.92487 0.745117 12C0.745117 18.0751 5.66998 23 11.7451 23Z" stroke="#DE3C41" stroke-width="1.5"/>
      <path d="M11.4374 17C13.4766 17 15.7451 15.3584 15.7451 13.3333C15.7451 10.4692 14.6637 9.75283 11.9941 6.65452C11.9167 6.56458 11.752 6.67119 11.7977 6.78075C12.6534 8.83155 12.5333 10.3447 11.4374 10.8889C10.2843 11.4614 9.49136 10.246 9.05847 9.75521C9.01691 9.7081 8.94325 9.71522 8.90915 9.76799C7.98008 11.2059 7.74512 12.7363 7.74512 13.3333C7.74512 15.3584 9.39822 17 11.4374 17Z" stroke="#DE3C41" stroke-width="1.5"/>
    </svg>
    )
}
export default heatEnabled;